import axios from "axios";
import { useEffect, useState } from "react";
import { format } from 'date-fns';
import config from "../../config";
import { BiSolidRightArrow } from "react-icons/bi";
import { BiSolidDownArrow } from "react-icons/bi";
import { Link } from "react-router-dom";
import { BsFiletypePdf } from "react-icons/bs";
import { BsFiletypeCsv } from "react-icons/bs";
import { useSelector } from "react-redux";

const BasketSubscriber = () => {

    const [stockHoldingList, setStockHoldingList] = useState([]);
    const [closedTransactionsList, setClosedTransactionsList] = useState([]);
    const [brokerList, setBrokerList] = useState([]);
    const [subsdbList, setsubsdbList] = useState([]);
    const [broker, setBroker] = useState("");
    const [err, setErr] = useState(null);
    const [accOpen, setAccOpen] = useState({})
    const [accTranOpen, setAccTranOpen] = useState({})
    const [basketId, setBasketId] = useState(null);

    const [basketList, setBasketList] = useState([]);
    const [subscriberList, setSubscriberList] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [basketName, setBasketName] = useState("")
    const [selectedClientId, setSelectedClientId] = useState(null);
    const [selectedBasketId, setSelectedBasketId] = useState(null);
    const [selectedBroker, setSelectedBroker] = useState('');
    const [isActiveClient, setIsActiveClient] = useState(true);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
    const [isLoading, setIsLoading] = useState(false);
    const [selectedBasketRow, setSelectedBasketRow] = useState(null);
    const companyId = useSelector((state) => state.user.companyId);
    //console.log(broker)
    useEffect(() => {
        const loadInitialData = async () => {
            if (brokerList && brokerList.length > 0) {
                // Use first broker (index 0) or second broker (index 1) if available
                const defaultBroker = brokerList.length > 1 ? brokerList[1] : brokerList[0];
                setSelectedBroker(defaultBroker.id);
                await getTableOneData({ target: { value: defaultBroker.id } }, isActiveClient);
            }
        };
        loadInitialData();
    }, [brokerList, isActiveClient]);

    useEffect(() => {
        // get Ingredients list --
        const getBrokerList = async (e) => {
            setErr("")
            try {
                const res = await axios.get(config.BL_API_URL + "/brokers/v1/getBrokers")
                //console.log(res.data)

                if (res)
                    setBrokerList(res.data)
                else
                    setErr("backend error")

            } catch (err) {
                console.log("error 333 ", err)
                if (err.response.status == 500)
                    setErr("Server error...");
                else
                    setErr(err.response.data);
            }
        }
        getBrokerList()
    }, [])



    const getTableOneData = async (e, activeClient) => {
        setSubscriberList(null);
        //setIsActiveClient(activeClient);
        setBroker(e.target.value);
        setSelectedBroker(e.target.value);
        await getBasketList(e.target.value, activeClient);
        setSelectedBasketId(null);
        setSelectedBasketRow(null);
        setSelectedClientId(null);
        setSelectedRow(null);
        setBasketName(null);
        setSortConfig({ key: null, direction: 'asc' });
    }

    async function getNoOfClients1(basketId) {
        return await getNoOfClients(basketId);
    }

    const getNoOfClients = async (basketId) => {
        let brokerId = basketId;
        let noOfClients = 0;
        const resCount = await axios.get(config.BL_API_URL + "/BrokerClientMap/v1/findClientCountByBrokerId", { params: { brokerId } })

        if (resCount) {
            noOfClients = resCount.data;
        }
        return noOfClients;
    }

    const getBasketList = async (value, activeClient) => {
        setErr("")
        setIsLoading(true);
        try {
            let brokerId = value;


            let res = null;
            if (activeClient) {
                res = await axios.get(config.BL_API_URL + "/BrokerClientMap/v1/getlist", { params: { brokerId, companyId } })

            } else {
                res = await axios.get(config.BL_API_URL + "/BrokerClientMap/v1/getInactiveList", { params: { brokerId, companyId } })
            }

            if (res && res != undefined && res.data != null) {
                setBasketList(res.data);
            }

            /*  if (res) {
                 let dataWithClients = await Promise.all(res.data.map(async (item) => {
                     let noOfClients = await getNoOfClients(item.basketId);
                     return { ...item, noOfClients };
                 }));
                 setBasketList(dataWithClients)
             } */
            /* else
                setErr("backend error") */

        } catch (err) {
            console.log("error 333 ", err)
            /* if (!err.response.data)
                setErr("Server error...");
            else
                setErr(err.response.data); */
        } finally {
            setIsLoading(false);
        }
    }

    const getBasketSubscriberList = async (value, basketName, activeClient) => {
        setErr("")
        setBasketName(basketName);
        setSelectedBasketId(value);
        setSelectedBasketRow(value);
        setSelectedClientId(null);
        setSelectedRow(null);
        setIsLoading(true);
        // Set default sorting to % column (returns) high to low
        setSortConfig({ key: 'returns', direction: 'desc' });
        try {
            //setAccOpen(false);
            let basketId = value;
            setBasketId(basketId);
            let res = null;
            if (activeClient) {
                res = await axios.get(config.BL_API_URL + "/BasketClientMap/v1/getlist", { params: { basketId } })
            } else {
                res = await axios.get(config.BL_API_URL + "/BasketClientMap/v1/getListInActiveClient", { params: { basketId } })
            }
            //console.log(res.data)

            if (res) {
                setSubscriberList(res.data)
            }
            else
                setErr("backend error")

        } catch (err) {
            console.log("error 333 ", err)
            if (!err.response.data)
                setErr("Server error...");
            else
                setErr(err.response.data);
        } finally {
            setIsLoading(false);
        }
    }

    const getNumOfSubscriber = (recipe_id) => {
        const tot = subsdbList.filter(item => item.recipe_id === recipe_id)
        return tot.length
    }

    function formatNumber(value) {
        return new Intl.NumberFormat('en-IN').format(value);
    }

    const calculateTotals = () => {
        if (!basketList || basketList.length === 0) {
            return { totalClients: 0, totalInvestmentValue: 0, totalCurrentValue: 0 };
        }

        return basketList.reduce((totals, item) => {
            return {
                totalClients: totals.totalClients + (item.noOfClients || 0),
                totalInvestmentValue: totals.totalInvestmentValue + (item.investmentValue || 0),
                totalCurrentValue: totals.totalCurrentValue + (item.currentValue || 0)
            };
        }, { totalClients: 0, totalInvestmentValue: 0, totalCurrentValue: 0 });
    };

    const handleSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    const getSortedSubscriberList = () => {
        if (!subscriberList || !sortConfig.key) {
            return subscriberList;
        }

        const sortedList = [...subscriberList].sort((a, b) => {
            let aValue, bValue;

            if (sortConfig.key === 'subscriptionDate') {
                aValue = new Date(a.subscriptionDate);
                bValue = new Date(b.subscriptionDate);
            } else if (sortConfig.key === 'redemptionDate') {
                aValue = new Date(a.redemptionDate);
                bValue = new Date(b.redemptionDate);
            } else if (sortConfig.key === 'cashBalance') {
                aValue = parseFloat(a.cashBalance) || 0;
                bValue = parseFloat(b.cashBalance) || 0;
            } else if (sortConfig.key === 'returns') {
                aValue = parseFloat(a.returns) || 0;
                bValue = parseFloat(b.returns) || 0;
            }

            if (aValue < bValue) {
                return sortConfig.direction === 'asc' ? -1 : 1;
            }
            if (aValue > bValue) {
                return sortConfig.direction === 'asc' ? 1 : -1;
            }
            return 0;
        });

        return sortedList;
    };

    const sortedSubscriberList = getSortedSubscriberList();

    const openPopup = () => {
        const width = 400;
        const height = 400;
        const left = (window.screen.width - width) / 2;
        const top = (window.screen.height - height) / 2;

        const newWindow = window.open('/BasketSubscriberReport', '_blank', 'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=no,width=400,height=400,modal=yes,top=${top},left=${left}`');
        if (newWindow) newWindow.opener = null;
    }

    const closeAll = () => {
        setAccOpen(prevState => {
            const newState = { ...prevState };
            for (let key in newState) {
                newState[key] = false;
            }
            return newState;
        });
    };

    const closeAllAccTran = () => {
        setAccTranOpen(prevState => {
            const newState = { ...prevState };
            for (let key in newState) {
                newState[key] = false;
            }
            return newState;
        });
    };

    const handleOpenClosedTransactions = async (basketId, clientCode) => {
        try {
            //setAccopen(!accOpen)
            closeAllAccTran()
            setAccTranOpen(prevState => ({ ...prevState, [`${basketId}-${clientCode}`]: !prevState[`${basketId}-${clientCode}`] }));

            const res = await axios.get(config.BL_API_URL + "/transaction/v1/getClosedTransactions", { params: { clientCode, basketId } });

            if (res.status === 200 && res.data)
                setClosedTransactionsList(res.data)
            else
                setErr("backend error while getting closed transactions")

        } catch (err) {
        }
    }

    const handleOpen = async (basketId, clientCode) => {
        try {
            //setAccopen(!accOpen)
            closeAll()
            setAccOpen(prevState => ({ ...prevState, [`${basketId}-${clientCode}`]: !prevState[`${basketId}-${clientCode}`] }));

            const res = await axios.get(config.BL_API_URL + "/BasketClientMap/v1/getBaskeClientStocktHolding", { params: { basketId, clientCode } });

            if (res.status === 200 && res.data)
                setStockHoldingList(res.data)
            else
                setErr("backend error")

        } catch (err) {


            setErr(err.message);
        }
    }

    const openHoldingReport = (clientCode, basketId) => {
        const width = 400;
        const height = 400;
        const left = (window.screen.width - width) / 2;
        const top = (window.screen.height - height) / 2;
        const axiosConfig = {
            responseType: 'blob',
            headers: {
                Accept: 'Application/csv'
            }
        }
        const url = `${config.BL_API_URL}/csvReport/v1/getHolding?clientCode=${encodeURIComponent(clientCode)}&basketId=${encodeURIComponent(basketId)}`;

        axios.get(url, axiosConfig).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `holding_report_${clientCode}_${getFormattedDate()}.csv`);
            document.body.appendChild(link);
            link.click();
        }).catch((error) => {
            console.log("error", error)
        }
        );
    }

    const openTransactionClosedReport = (clientCode, basketId) => {
        const width = 400;
        const height = 400;
        const left = (window.screen.width - width) / 2;
        const top = (window.screen.height - height) / 2;
        const axiosConfig = {
            responseType: 'blob',
            headers: {
                Accept: 'Application/csv'
            }
        }
        const url = `${config.BL_API_URL}/csvReport/v1/getClosedTransactions?clientCode=${encodeURIComponent(clientCode)}&basketId=${encodeURIComponent(basketId)}`;

        axios.get(url, axiosConfig).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `transaction_closed_report_${clientCode}_${getFormattedDate()}.csv`);
            document.body.appendChild(link);
            link.click();
        }).catch((error) => {
            console.log("error", error)
        }
        );
    }

    function PRNG(seed, modulo) {
        let str = `${(2 ** 31 - 1 & Math.imul(48271, seed)) / 2 ** 31}`
            .split('')
            .slice(-10)
            .join('') % modulo

        return str
    }

    const onClientRowSelected = (e) => {
        setSelectedRow(e.currentTarget.cells[0].innerText);
        setSelectedClientId(e.currentTarget.cells[1].innerText);
    }

    function getFormattedDate() {
        const now = new Date();
        const formattedDate = now.toISOString().split('T')[0]; // Format date to avoid invalid characters in file name
        return formattedDate;
    }

    const downloadAUMReport = (companyId) => {
        const width = 400;
        const height = 400;
        const left = (window.screen.width - width) / 2;
        const top = (window.screen.height - height) / 2;
        const axiosConfig = {
            responseType: 'blob',
            headers: {
                Accept: 'Application/csv'
            }
        }
        const url = `${config.BL_API_URL}/csvReport/v1/getAUMReport?companyId=${encodeURIComponent(companyId)}`;

        axios.get(url, axiosConfig).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `AUM_Report_${getFormattedDate()}.xlsx`);
            document.body.appendChild(link);
            link.click();
        }).catch((error) => {
            console.log("error", error)
        });
    }

    function removeSpacesFromBasketName(basketName) {
        return basketName.replace(/\s+/g, '');
    }

    const downloadAllClients = (basketId) => {
        const width = 400;
        const height = 400;
        const left = (window.screen.width - width) / 2;
        const top = (window.screen.height - height) / 2;
        const axiosConfig = {
            responseType: 'blob',
            headers: {
                Accept: 'Application/csv'
            }
        }
        const url = `${config.BL_API_URL}/csvReport/v1/getAllClientsByBasketId?basketId=${encodeURIComponent(basketId)}`;

        axios.get(url, axiosConfig).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${removeSpacesFromBasketName(basketName)}_client_list_${getFormattedDate()}.csv`);
            document.body.appendChild(link);
            link.click();
        }).catch((error) => {
            console.log("error", error)
        }
        );
    }
    const downloadAdditionalInvestmentCalculations = (clientCode, basketId) => {
        const width = 400;
        const height = 400;
        const left = (window.screen.width - width) / 2;
        const top = (window.screen.height - height) / 2;
        const axiosConfig = {
            responseType: 'blob',
            headers: {
                Accept: 'Application/csv'
            }
        }
        const url = `${config.BL_API_URL}/csvReport/v1/getAdditionalInvestmentCalculations?clientCode=${encodeURIComponent(clientCode)}&basketId=${encodeURIComponent(basketId)}`;

        axios.get(url, axiosConfig).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'allocation_' + clientCode + '.csv');
            document.body.appendChild(link);
            link.click();
        }).catch((error) => {
            console.log("error", error)
        }
        );
    }

    const openReport = (clientCode, basketId) => {
        const width = 400;
        const height = 400;
        const left = (window.screen.width - width) / 2;
        const top = (window.screen.height - height) / 2;
        const axiosConfig = {
            responseType: 'arraybuffer',
            headers: {
                Accept: 'Application/pdf'
            }
        }
        const url = `${config.BL_API_URL}/report/v1/performanceReport?clientCode=${encodeURIComponent(clientCode)}&basketId=${encodeURIComponent(basketId)}`;

        axios.get(url, axiosConfig).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `performance_report_${clientCode}_${getFormattedDate()}.pdf`);
            document.body.appendChild(link);
            link.click();
        }).catch((error) => {
            console.log("error", error)
        }
        );
    };

    const changeClientStatus = async (newValue) => {
        try {
            setIsLoading(true);
            setIsActiveClient(newValue);
            await getBasketList(broker, newValue);

            setSubscriberList(null);
            //changeClientStatus(true);
            setSelectedBasketId(null);
            setSelectedBasketRow(null);
            setSelectedClientId(null);
            setSelectedRow(null);
            setBasketName(null);
            setSortConfig({ key: null, direction: 'asc' });
            setErr("")

        } catch (err) {
            //console.log("first")
            if (err.response)
                setErr(err.response.data);
            else
                setErr("Server error...");
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <div className=" w-full transform ">
            <div className="z-0 relative  w-full  flex justify-center items-start  ">
                <div className="b order  relative  w-full ">
                    <div className="p-0 md:p-0 w-full">
                        <div className=" w-full">
                            <div className="grid sm:grid-cols-12 gap-0 sm:gap-0 w-full">
                                {/* Table 1 ---- */}
                                <div className="sm:col-span-3 pr-2">
                                    <div className="flex flex-col pt-4" aria-label="Table navigation">
                                        <div className="px-0 mb-2">
                                            <form className="">
                                                <select value={selectedBroker} onChange={async (e) => await getTableOneData(e, isActiveClient)}
                                                    id="broker" name="broker" className="min-w-[100px] bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full px-2.5 py-1 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                                                    {brokerList &&
                                                        brokerList.map((broker, index) => (
                                                            <option key={index} value={broker.id}>{broker.name}</option>
                                                        ))
                                                    }
                                                </select>
                                            </form>
                                        </div>
                                        <div className="flex items-center gap-2 mb-4">
                                            <label class="flex items-center relative w-max cursor-pointer select-none">
                                                <input type="checkbox" className={`appearance-none transition-colors cursor-pointer w-24 h-7 rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-black focus:ring-blue-500 ${isActiveClient ? 'bg-green-500' : 'bg-red-500'}`} checked={isActiveClient}
                                                    onChange={(e) => changeClientStatus(e.target.checked)} disabled={isLoading} />
                                                {isActiveClient &&
                                                    <span class={`absolute font-small text-xs uppercase right-11 text-white `}> Active </span>
                                                }
                                                {!isActiveClient &&
                                                    <span class={`absolute font-small text-xs uppercase right-1 text-white`}> In-Active </span>
                                                }
                                                <span class={`w-9 h-7 ${isActiveClient ? 'right-0' : 'right-15'}  absolute rounded-full transform transition-transform bg-gray-200`} />
                                            </label>
                                            <label className="">Clients</label>
                                            {isLoading && (
                                                <div className="flex items-center ml-2">
                                                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-500"></div>
                                                    <span className="ml-2 text-xs text-blue-600">Loading...</span>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="relative overflow-x-auto">
                                        {isLoading && (
                                            <div className="absolute inset-0 bg-white bg-opacity-75 flex items-center justify-center z-10">
                                                <div className="flex flex-col items-center">
                                                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500 mb-2"></div>
                                                    <span className="text-sm text-gray-600">Refreshing data...</span>
                                                </div>
                                            </div>
                                        )}
                                        <table className="text-xs text-left rtl:text-right dark:text-gray-400" style={{ tableLayout: 'fixed', width: '100%' }}>
                                            <thead style={{ minHeight: '200px' }} className="text-xs text-white uppercase bg-tblPrimary dark:bg-gray-700 dark:text-gray-400">
                                                <tr className="">
                                                    <th scope="col" className="px-1 py-3 text-left" style={{ width: '30%' }}>
                                                        Basket Name
                                                    </th>
                                                    <th scope="col" className="px-1 py-3 text-center" style={{ width: '10%' }}>
                                                        TOTAL Clients
                                                    </th>
                                                    <th scope="col" className="px-1 py-3 text-right" style={{ width: '30%' }}>
                                                        Investment AUM
                                                    </th>
                                                    <th scope="col" className="px-1 py-3 text-right" style={{ width: '30%' }}>
                                                        Current AUM VALUE
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {basketList &&
                                                    basketList.map((item, index) => (
                                                        <tr onClick={e => getBasketSubscriberList(item.basketId, item.basketName, isActiveClient)} key={index} className={`cursor-pointer border-b transition-all duration-200 ${
                                                            selectedBasketRow === item.basketId 
                                                                ? 'bg-blue-50 border-blue-200 shadow-sm ring-1 ring-blue-200 dark:bg-blue-900 dark:border-blue-700' 
                                                                : 'bg-white hover:bg-gray-50 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-600'
                                                        }`}>
                                                            <td className="px-1 py-2 font-medium text-gray-900 whitespace-wrap dark:text-white text-left" style={{ width: '30%' }}>
                                                                {item.basketName}
                                                            </td>
                                                            <td className="px-1 py-2 text-center" style={{ width: '10%' }}>
                                                                {item.noOfClients}
                                                            </td>
                                                            <td className="px-1 py-2 text-right whitespace-nowrap overflow-hidden" displayType="text" style={{ width: '30%' }}>
                                                                {formatNumber(item.investmentValue)}
                                                            </td>
                                                            <td className="px-1 py-2 text-right whitespace-nowrap overflow-hidden" style={{ width: '30%' }}>
                                                                {formatNumber(item.currentValue)}
                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </table>
                                        
                                        {/* Totals Row */}
                                        {basketList && basketList.length > 0 && (
                                            <div className="mt-2 bg-gray-50 border-t border-gray-200">
                                                <div className="flex items-center text-xs font-semibold text-gray-700 py-2">
                                                    <div style={{ width: '30%' }} className="px-1 text-left">
                                                        Total
                                                    </div>
                                                    <div style={{ width: '10%' }} className="px-1 text-center">
                                                        {calculateTotals().totalClients}
                                                    </div>
                                                    <div style={{ width: '30%' }} className="px-1 text-right">
                                                        {formatNumber(calculateTotals().totalInvestmentValue)}
                                                    </div>
                                                    <div style={{ width: '30%' }} className="px-1 text-right">
                                                        {formatNumber(calculateTotals().totalCurrentValue)}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="sm:col-span-9 pl-2">
                                    <div className="flex items-start justify-between pt-4 pb-2" aria-label="Table navigation">
                                        {/* Selected Info Section */}
                                        <div className="flex gap-6">
                                            <div className="flex flex-col">
                                                <span className="text-xs font-medium text-gray-600 uppercase tracking-wide">Selected Basket</span>
                                                <span className="text-sm font-semibold text-gray-900 bg-yellow-50 px-2 py-1 rounded border border-yellow-200 flex items-center">
                                                    {basketName === null ? 'None' : basketName}
                                                    {isLoading && basketName && (
                                                        <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-blue-500 ml-2"></div>
                                                    )}
                                                </span>
                                            </div>
                                            <div className="flex flex-col">
                                                <span className="text-xs font-medium text-gray-600 uppercase tracking-wide">Selected Client</span>
                                                <span className="text-sm font-semibold text-gray-900 bg-green-50 px-2 py-1 rounded border border-green-200">
                                                    {selectedRow === null ? 'None' : selectedRow}
                                                </span>
                                            </div>
                                        </div>
                                        
                                        {/* Download Actions */}
                                        <div className="flex gap-3 items-end">
                                            {/* AUM Report */}
                                            <div className="flex flex-col items-center min-h-[60px] justify-end">
                                                <a 
                                                    title="Download AUM Report" 
                                                    href="#" 
                                                    onClick={e => downloadAUMReport(companyId)}
                                                    className="inline-flex items-center justify-center w-10 h-10 bg-blue-100 hover:bg-blue-200 rounded-lg transition-colors duration-200 group"
                                                >
                                                    <BsFiletypeCsv size={20} className="text-blue-600 group-hover:text-blue-700" />
                                                </a>
                                                <span className="text-xs text-center mt-1 text-gray-600 leading-tight">AUM Report</span>
                                            </div>

                                            {/* All Clients */}
                                            <div className="flex flex-col items-center min-h-[60px] justify-end">
                                                <button
                                                    title="Download all basket clients"
                                                    onClick={e => downloadAllClients(selectedBasketId)}
                                                    disabled={!selectedBasketId}
                                                    className={`inline-flex items-center justify-center w-10 h-10 rounded-lg transition-colors duration-200 group ${
                                                        selectedBasketId 
                                                            ? 'bg-green-100 hover:bg-green-200 cursor-pointer' 
                                                            : 'bg-gray-100 cursor-not-allowed'
                                                    }`}
                                                >
                                                    <BsFiletypeCsv 
                                                        size={20} 
                                                        className={selectedBasketId ? 'text-green-600 group-hover:text-green-700' : 'text-gray-400'} 
                                                    />
                                                </button>
                                                <span className="text-xs text-center mt-1 text-gray-600 leading-tight">All Clients</span>
                                            </div>

                                            {/* Additional Investment */}
                                            <div className="flex flex-col items-center min-h-[60px] justify-end">
                                                <button
                                                    title="Download additional investment calculations"
                                                    onClick={e => downloadAdditionalInvestmentCalculations(selectedClientId, selectedBasketId)}
                                                    disabled={!selectedClientId || !selectedBasketId}
                                                    className={`inline-flex items-center justify-center w-10 h-10 rounded-lg transition-colors duration-200 group ${
                                                        selectedClientId && selectedBasketId 
                                                            ? 'bg-purple-100 hover:bg-purple-200 cursor-pointer' 
                                                            : 'bg-gray-100 cursor-not-allowed'
                                                    }`}
                                                >
                                                    <BsFiletypeCsv 
                                                        size={20} 
                                                        className={selectedClientId && selectedBasketId ? 'text-purple-600 group-hover:text-purple-700' : 'text-gray-400'} 
                                                    />
                                                </button>
                                                <span className="text-xs text-center mt-1 text-gray-600">Investment</span>
                                            </div>

                                            {/* Performance Report */}
                                            <div className="flex flex-col items-center min-h-[60px] justify-end">
                                                <button
                                                    title="Download selected client's performance report"
                                                    onClick={e => openReport(selectedClientId, selectedBasketId)}
                                                    disabled={!selectedClientId || !selectedBasketId}
                                                    className={`inline-flex items-center justify-center w-10 h-10 rounded-lg transition-colors duration-200 group ${
                                                        selectedClientId && selectedBasketId 
                                                            ? 'bg-red-100 hover:bg-red-200 cursor-pointer' 
                                                            : 'bg-gray-100 cursor-not-allowed'
                                                    }`}
                                                >
                                                    <BsFiletypePdf 
                                                        size={20} 
                                                        className={selectedClientId && selectedBasketId ? 'text-red-600 group-hover:text-red-700' : 'text-gray-400'} 
                                                    />
                                                </button>
                                                <span className="text-xs text-center mt-1 text-gray-600">Performance</span>
                                            </div>

                                            {/* Holding Report */}
                                            <div className="flex flex-col items-center min-h-[60px] justify-end">
                                                <button
                                                    title="Download holding report for selected client"
                                                    onClick={e => openHoldingReport(selectedClientId, selectedBasketId)}
                                                    disabled={!selectedClientId || !selectedBasketId}
                                                    className={`inline-flex items-center justify-center w-10 h-10 rounded-lg transition-colors duration-200 group ${
                                                        selectedClientId && selectedBasketId 
                                                            ? 'bg-teal-100 hover:bg-teal-200 cursor-pointer' 
                                                            : 'bg-gray-100 cursor-not-allowed'
                                                    }`}
                                                >
                                                    <BsFiletypeCsv 
                                                        size={20} 
                                                        className={selectedClientId && selectedBasketId ? 'text-teal-600 group-hover:text-teal-700' : 'text-gray-400'} 
                                                    />
                                                </button>
                                                <span className="text-xs text-center mt-1 text-gray-600">Holdings</span>
                                            </div>

                                            {/* Transaction Report */}
                                            <div className="flex flex-col items-center min-h-[60px] justify-end">
                                                <button
                                                    title="Download transaction closed report for selected client"
                                                    onClick={e => openTransactionClosedReport(selectedClientId, selectedBasketId)}
                                                    disabled={!selectedClientId || !selectedBasketId}
                                                    className={`inline-flex items-center justify-center w-10 h-10 rounded-lg transition-colors duration-200 group ${
                                                        selectedClientId && selectedBasketId 
                                                            ? 'bg-orange-100 hover:bg-orange-200 cursor-pointer' 
                                                            : 'bg-gray-100 cursor-not-allowed'
                                                    }`}
                                                >
                                                    <BsFiletypeCsv 
                                                        size={20} 
                                                        className={selectedClientId && selectedBasketId ? 'text-orange-600 group-hover:text-orange-700' : 'text-gray-400'} 
                                                    />
                                                </button>
                                                <span className="text-xs text-center mt-1 text-gray-600">Transactions</span>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Table 2 ---- */}
                                    <div className="relative overflow-x-auto">
                                        {isLoading && (
                                            <div className="absolute inset-0 bg-white bg-opacity-75 flex items-center justify-center z-10">
                                                <div className="flex flex-col items-center">
                                                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500 mb-2"></div>
                                                    <span className="text-sm text-gray-600">Loading clients...</span>
                                                </div>
                                            </div>
                                        )}
                                        <div className="mt-4">
                                            <div className="max-h-96 overflow-y-auto">
                                                <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400" style={{ tableLayout: 'fixed' }}>
                                                    <thead className="sticky top-0 text-xs text-white uppercase bg-tblPrimary dark:bg-gray-700 dark:text-gray-400">
                                                        <tr>
                                                            <th scope="col" className="px-2 py-3 text-wrap border-r" style={{ width: '180px' }}>
                                                                Client Name
                                                            </th>
                                                            <th scope="col" className="px-2 py-1 text-wrap border-r" style={{ width: '90px' }}>
                                                                Client Code
                                                            </th>
                                                            {isActiveClient ? (
                                                                <th scope="col" className="px-2 py-3 text-wrap border-r cursor-pointer hover:bg-blue-700 transition-colors" style={{ width: '110px' }} onClick={() => handleSort('subscriptionDate')}>
                                                                    <div className="flex items-center justify-center">
                                                                        Subscription Date
                                                                        {sortConfig.key === 'subscriptionDate' && (
                                                                            <span className="ml-1">
                                                                                {sortConfig.direction === 'asc' ? '↑' : '↓'}
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                </th>
                                                            ) : (
                                                                <>
                                                                    <th scope="col" className="px-2 py-3 text-wrap border-r cursor-pointer hover:bg-blue-700 transition-colors" style={{ width: '110px' }} onClick={() => handleSort('subscriptionDate')}>
                                                                        <div className="flex items-center justify-center">
                                                                            Subscription Date
                                                                            {sortConfig.key === 'subscriptionDate' && (
                                                                                <span className="ml-1">
                                                                                    {sortConfig.direction === 'asc' ? '↑' : '↓'}
                                                                                </span>
                                                                            )}
                                                                        </div>
                                                                    </th>
                                                                    <th scope="col" className="px-2 py-3 text-wrap border-r cursor-pointer hover:bg-blue-700 transition-colors" style={{ width: '110px' }} onClick={() => handleSort('redemptionDate')}>
                                                                        <div className="flex items-center justify-center">
                                                                            Redemption Date
                                                                            {sortConfig.key === 'redemptionDate' && (
                                                                                <span className="ml-1">
                                                                                    {sortConfig.direction === 'asc' ? '↑' : '↓'}
                                                                                </span>
                                                                            )}
                                                                        </div>
                                                                    </th>
                                                                </>
                                                            )}
                                                            <th scope="col" className="px-2 py-3 text-wrap border-r text-right" style={{ width: '95px' }}>
                                                                Initial Investment
                                                            </th>
                                                            {isActiveClient && (
                                                                <th scope="col" className="px-2 py-3 text-wrap border-r text-right" style={{ width: '95px' }}>
                                                                    Additional Investment
                                                                </th>
                                                            )}
                                                            {isActiveClient && (
                                                                <th scope="col" className="px-2 py-3 text-wrap border-r text-right" style={{ width: '100px' }}>
                                                                    Withdrawals
                                                                </th>
                                                            )}
                                                            {isActiveClient && (
                                                                <th scope="col" className="px-2 py-3 text-wrap border-r text-right" style={{ width: '100px' }}>
                                                                    Initial Stocks Bought Value
                                                                </th>
                                                            )}
                                                            {isActiveClient && (
                                                                <th scope="col" className="px-2 py-3 text-wrap border-r text-right" style={{ width: '95px' }}>
                                                                    Current Value
                                                                </th>
                                                            )}
                                                            <th scope="col" className="px-2 py-3 text-wrap border-r text-center cursor-pointer hover:bg-blue-700 transition-colors" style={{ width: '40px' }} onClick={() => handleSort('returns')}>
                                                                <div className="flex items-center justify-center">
                                                                    %
                                                                    {sortConfig.key === 'returns' && (
                                                                        <span className="ml-1">
                                                                            {sortConfig.direction === 'asc' ? '↑' : '↓'}
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            </th>
                                                            <th scope="col" className="px-2 py-3 text-wrap border-r text-right cursor-pointer hover:bg-blue-700 transition-colors" style={{ width: '95px' }} onClick={() => handleSort('cashBalance')}>
                                                                <div className="flex items-center justify-end">
                                                                    Cash Balance
                                                                    {sortConfig.key === 'cashBalance' && (
                                                                        <span className="ml-1">
                                                                            {sortConfig.direction === 'asc' ? '↑' : '↓'}
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {sortedSubscriberList &&
                                                            sortedSubscriberList.map((subscriber, index) => (
                                                                <tr
                                                                    key={index}
                                                                    data={subscriber.clientCode}
                                                                    onClick={e => onClientRowSelected(e)}
                                                                    className={`border-b border cursor-pointer transition-all duration-200 ${
                                                                        selectedRow === subscriber.clientName 
                                                                            ? 'bg-blue-50 border-blue-200 shadow-sm ring-1 ring-blue-200 dark:bg-blue-900 dark:border-blue-700' 
                                                                            : index % 2 === 0 
                                                                                ? 'bg-white hover:bg-gray-50 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-600'
                                                                                : 'bg-gray-50 hover:bg-gray-100 dark:bg-gray-700 dark:border-gray-600 dark:hover:bg-gray-500'
                                                                    }`}
                                                                >
                                                                    <td className="px-2 py-2 font-small border-r text-gray-900 whitespace-wrap dark:text-white overflow-hidden uppercase" style={{ width: '180px' }}>
                                                                        {subscriber.clientName.toUpperCase()}
                                                                    </td>
                                                                    <td className="px-2 py-2 font-small border-r text-gray-900 whitespace-nowrap dark:text-white" style={{ width: '90px' }}>
                                                                        {subscriber.clientCode}
                                                                    </td>
                                                                    {isActiveClient ? (
                                                                        <td className="px-2 py-2 font-small border-r text-gray-900 whitespace-nowrap dark:text-white" style={{ width: '110px' }}>
                                                                            {format(subscriber.subscriptionDate, 'dd/MMM/yyyy')}
                                                                        </td>
                                                                    ) : (
                                                                        <>
                                                                            <td className="px-2 py-2 font-small border-r text-gray-900 whitespace-nowrap dark:text-white" style={{ width: '110px' }}>
                                                                                {format(subscriber.subscriptionDate, 'dd/MMM/yyyy')}
                                                                            </td>
                                                                            <td className="px-2 py-2 font-small border-r text-gray-900 whitespace-nowrap dark:text-white" style={{ width: '110px' }}>
                                                                                {subscriber.redemptionDate ? format(subscriber.redemptionDate, 'dd/MMM/yyyy') : '-'}
                                                                            </td>
                                                                        </>
                                                                    )}
                                                                    <td className="px-2 py-2 font-small border-r text-gray-900 whitespace-nowrap dark:text-white text-right" style={{ width: '95px' }}>
                                                                        {formatNumber(subscriber.initialInvestment)}
                                                                    </td>
                                                                    {isActiveClient && (
                                                                        <td className="px-2 py-2 font-small border-r text-gray-900 whitespace-nowrap dark:text-white text-right" style={{ width: '95px' }}>
                                                                            {formatNumber(subscriber.additionalInvestment)}
                                                                        </td>
                                                                    )}
                                                                    {isActiveClient && (
                                                                        <td className="px-2 py-2 font-small border-r text-gray-900 whitespace-nowrap dark:text-white text-right" style={{ width: '100px' }}>
                                                                            {formatNumber(subscriber.withdrawals)}
                                                                        </td>
                                                                    )}
                                                                    {isActiveClient && (
                                                                        <td className="px-1 py-2 font-small border-r text-gray-900 whitespace-wrap dark:text-white text-right" style={{ width: '100px' }}>
                                                                            {formatNumber(subscriber.investmentValue)}
                                                                        </td>
                                                                    )}
                                                                    {isActiveClient && (
                                                                        <td className="px-1 py-2 font-small border-r text-gray-900 whitespace-wrap dark:text-white text-right" style={{ width: '95px' }}>
                                                                            {formatNumber(subscriber.currentValue)}
                                                                        </td>
                                                                    )}
                                                                    <td className="px-1 py-2 font-small border-r text-gray-900 whitespace-wrap dark:text-white text-center" style={{ width: '40px' }}>
                                                                        {Math.round(subscriber.returns, 2)}
                                                                    </td>
                                                                    <td className="px-1 py-2 font-small border-r text-gray-900 whitespace-wrap dark:text-white text-right" style={{ width: '95px' }}>
                                                                        {formatNumber(subscriber.cashBalance)}
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default BasketSubscriber